// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__N_rfg","selected":"Chip_selected__3cDpp"};